<template>
  <div
    style="z-index:100000000"
    class="container mx-auto flex justify-between items-center"
  >
    <div class="flex items-center">
      <div
        @click="$router.push('/')"
        class="logo ml-2 mt-2 lg:mt-8 lg:ml-8 cursor-pointer"
        v-html="logo"
      ></div>
      <div
        id="left"
        class="hidden lg:flex font-medium leading-normal text-green-900"
      >
        <div
          @click="scrollTo(item.code)"
          class="ml-8 cursor-pointer text-green font-bold"
          :key="item.code"
          v-for="item of menu"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
    <div id="right" class="flex" @mouseleave="hideShoppingCart">
      <!-- 
      <div
        @mouseenter="windowWidth > 600 ? (showShoppingCart = true) : false"
        class="reative"
      >
        <menuButton
          @on-click="openCart"
          :active="showShoppingCart"
          class="mr-4"
          text="Krepšelis"
          :mobile="windowWidth < 600"
          :status="getCartItemsNumber"
          icon="cart"
        />
      </div> -->
      <menuButton
        @set-active="showAccount"
        :mobile="windowWidth < 600"
        :active="shoppingCartActive || $root.showUserAccount"
        @on-click="openAccount"
        :text="
          user
            ? user.name.length > 10
              ? user.name.substring(0, 10) + '...'
              : user.name
            : 'Prisijungti'
        "
        :bold="user"
        icon="person"
      />
      <menuButton
        id="some"
        mobile
        :icon="slideOutOpen ? 'closeIcon' : 'cart'"
        :status="getCartItemsNumber"
        class="block mr-4 ml-4"
      />
    </div>
  </div>
</template>

<script>
import menuButton from "./smallComponents/menuButton";
import { mapState } from "vuex";

export default {
  data() {
    return {
      showShoppingCart: false,
      windowWidth: null,
      shoppingCartActive: false,
      userAccountOpen: false,
      logo:
        '<svg width="117" height="118" viewBox="0 0 117 118" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.40186 59.504L59.5604 1.22391L114.52 56.3002L113.693 60.4399L113.046 64.0037L59.4885 117.676L1.40186 59.504Z" fill="#F9D77A"/> <path d="M1.40186 59.504L59.5604 1.22391L114.52 56.3002L113.693 60.4399L113.046 64.0037L59.4885 117.676L1.40186 59.504Z" stroke="black" stroke-width="0.216" stroke-miterlimit="22.9256"/> <path d="M111.896 58.676C111.896 57.0561 111.069 55.6162 109.452 54.4283L62.6876 7.77547C61.5373 6.26358 60.0995 5.54362 58.3382 5.54362C56.7207 5.54362 55.2111 6.37157 53.917 7.99146L8.1235 53.7084C6.1106 55.7242 5.14009 57.4521 5.14009 58.928C5.14009 60.4399 5.82304 61.8798 7.153 63.2477L53.8811 110.117C55.4627 111.664 57.0083 112.456 58.518 112.456C59.812 112.456 61.2138 111.664 62.7594 110.081L109.416 63.3197C111.069 62.0238 111.896 60.4759 111.896 58.676ZM117 59.216C116.928 61.0159 116.353 62.4198 115.347 63.4637L63.083 115.912C61.6811 117.316 60.2433 118 58.6977 118C56.9724 118 55.4267 117.28 54.0608 115.912L1.50968 63.2477C0.503226 61.8078 0 60.3319 0 58.82C0 57.0561 0.647005 55.5082 1.97696 54.1403L53.9889 2.01586C55.3189 0.683954 56.7207 0 58.1945 0C59.5963 0 61.2498 0.647956 63.2267 1.97987L115.239 54.1403C116.461 55.7962 117.036 57.4881 117 59.216Z" fill="#001E19"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M50.6462 105.365L87.202 68.6833C88.6757 67.2074 90.8324 66.9555 92.0185 68.1074L98.6324 74.7309C99.7826 75.8829 99.531 78.0787 98.0573 79.5546L61.4655 116.236C59.9918 117.712 57.8351 117.964 56.6489 116.812L50.0351 110.189C48.9208 109.037 49.1724 106.877 50.6462 105.365Z" fill="black"/> <path d="M50.6462 105.365L87.202 68.6833C88.6757 67.2074 90.8324 66.9555 92.0185 68.1074L98.6324 74.7309C99.7826 75.8829 99.531 78.0787 98.0573 79.5546L61.4655 116.236C59.9918 117.712 57.8351 117.964 56.6489 116.812L50.0351 110.189C48.9208 109.037 49.1724 106.877 50.6462 105.365Z" fill="#001E19"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M42.6304 59.72C46.5124 53.7084 51.7963 43.881 56.7566 37.9774C66.3539 24.1184 81.1631 23.3624 90.329 39.4533C76.2027 18.4307 62.7594 31.2819 57.4396 38.5534C51.329 46.7608 49.0285 50.9725 43.8884 60.1159C43.6368 60.0439 42.9179 59.7919 42.6304 59.72Z" fill="black"/> <path d="M42.6304 59.72C46.5124 53.7084 51.7963 43.881 56.7566 37.9774C66.3539 24.1184 81.1631 23.3624 90.329 39.4533C76.2027 18.4307 62.7594 31.2819 57.4396 38.5534C51.329 46.7608 49.0285 50.9725 43.8884 60.1159C43.6368 60.0439 42.9179 59.7919 42.6304 59.72Z" fill="#001E19"/> <path d="M40.2938 57.4881C40.186 59.144 41.0127 59.432 41.0846 62.3478L42.7381 58.892L40.2938 57.4881ZM29.4026 60.4399L26.7427 64.9036C28.1445 66.1995 30.8404 66.7395 32.1703 67.4594L29.4026 60.4399ZM46.009 56.4442L41.9832 66.1275C46.3325 69.1873 53.0542 76.5308 53.8809 77.5388C56.2533 80.3826 57.8348 86.6821 60.315 94.7816C60.8901 96.6535 56.7206 97.8414 56.0017 96.0775C51.9759 86.2862 51.0054 80.5625 46.5482 77.6467L40.4017 73.975L41.9473 81.3545C41.5519 84.1983 40.5454 85.1342 39.6109 86.5021C36.4118 93.4497 34.6146 93.3777 31.0201 91.7578L36.3759 82.1104L34.7943 74.7309C34.6865 74.227 35.8007 77.6827 35.01 75.3429C34.7224 75.5589 34.6505 76.4228 33.9316 77.3228C32.9252 78.8347 31.7749 81.5345 31.5593 81.4265C31.056 81.2105 29.5823 80.6705 29.798 80.2026C29.8699 80.0226 32.6017 75.4869 33.033 74.587L34.2192 71.5272C31.3436 69.7633 24.1187 68.9713 22.7169 67.3874C21.7464 66.3435 21.4947 65.4076 21.8183 64.6516L27.174 52.5565C27.5694 51.6565 31.056 50.5766 34.5786 50.0726C38.1012 49.5687 42.5943 53.5284 43.2772 53.8524C45.0385 54.6443 47.5547 44.241 50.7537 45.2849C53.5215 44.061 47.4109 55.6522 46.009 56.4442Z" fill="#001E19"/> <path d="M30.8765 48.8847C34.4299 48.8847 37.3106 45.9998 37.3106 42.4411C37.3106 38.8824 34.4299 35.9976 30.8765 35.9976C27.323 35.9976 24.4424 38.8824 24.4424 42.4411C24.4424 45.9998 27.323 48.8847 30.8765 48.8847Z" fill="#001E19"/> <path d="M30.8765 48.8847C34.4299 48.8847 37.3106 45.9998 37.3106 42.4411C37.3106 38.8824 34.4299 35.9976 30.8765 35.9976C27.323 35.9976 24.4424 38.8824 24.4424 42.4411C24.4424 45.9998 27.323 48.8847 30.8765 48.8847Z" stroke="black" stroke-width="0.216" stroke-miterlimit="22.9256"/> <path d="M95.3252 73.939C95.9003 74.5149 96.2238 75.1629 96.2957 75.9548C96.3676 76.7108 96.2238 77.4667 95.7925 78.2227C95.4331 78.8346 95.0017 79.4466 94.4266 79.9866C93.9953 80.4185 93.528 80.7785 93.0607 81.1025C92.5934 81.3905 92.0543 81.6065 91.5151 81.7144C90.9759 81.8224 90.4367 81.7864 89.8976 81.6425C89.3584 81.4985 88.8911 81.2105 88.4238 80.8505L90.7962 78.4747C91.0478 78.6187 91.2994 78.7267 91.5151 78.7267C91.7308 78.7267 91.9464 78.6907 92.1621 78.5467C92.3778 78.4027 92.5934 78.2587 92.7732 78.0787C93.0967 77.7547 93.2764 77.4307 93.3123 77.1428C93.3483 76.9268 93.2764 76.7108 93.1326 76.5668C92.9888 76.4228 92.845 76.3868 92.6653 76.4228C92.4137 76.4588 92.0543 76.6028 91.587 76.8908C91.2275 77.1068 90.904 77.3227 90.5446 77.5387C89.8616 77.9347 89.3584 78.1867 89.0709 78.2947C88.4957 78.5467 87.9925 78.6547 87.5612 78.6547C87.022 78.6547 86.4828 78.4747 86.0156 78.1147L85.5842 77.7187C85.081 77.2148 84.7575 76.6028 84.6856 75.9188C84.5778 75.2349 84.7215 74.5149 85.045 73.831C85.3326 73.219 85.7639 72.6431 86.3031 72.1031C86.7704 71.6351 87.2377 71.2752 87.7049 70.9872C88.1722 70.6992 88.6755 70.4832 89.2146 70.4112C89.7538 70.3032 90.2211 70.3392 90.6524 70.4472C91.0837 70.5912 91.551 70.8432 92.0183 71.2032L89.7179 73.507C89.2506 73.219 88.8192 73.255 88.3879 73.543L87.9925 73.867C87.8487 74.011 87.7409 74.155 87.6331 74.2989C87.5612 74.4429 87.5252 74.5869 87.5252 74.7309C87.5252 74.8749 87.5971 75.0189 87.7049 75.1269C87.8128 75.2349 87.9566 75.3069 88.1363 75.3069C88.352 75.3069 88.8192 75.0909 89.5022 74.6589C90.1851 74.227 90.6165 73.975 90.7243 73.903C91.4432 73.471 92.1261 73.183 92.7372 73.075C93.528 72.931 94.2109 73.111 94.7861 73.543L95.3252 73.939ZM84.6856 84.1263L81.163 82.3984L82.8524 85.9622L84.6856 84.1263ZM90.4727 83.5143L88.0644 85.9622L86.7704 85.2782L83.9308 88.122L84.6137 89.4539L82.2414 91.8298L77.5326 81.3545L80.0128 78.8706L90.4727 83.5143ZM76.9215 85.9262L74.5133 88.374L80.0847 93.9896L77.6404 96.4375L72.069 90.8218L69.5888 93.3057L67.6119 91.3258L74.9446 83.9823L76.9215 85.9262ZM68.4027 98.0573C67.7916 97.4454 67.1805 97.0494 66.6773 96.9054C65.9944 96.7254 65.3833 96.9414 64.8082 97.5174C64.2331 98.0933 64.0174 98.7053 64.1971 99.3893C64.3409 99.9292 64.7363 100.505 65.3474 101.153C65.9944 101.801 66.5695 102.161 67.0727 102.305C67.7557 102.485 68.3667 102.305 68.9418 101.693C69.5169 101.117 69.7326 100.469 69.5529 99.8212C69.4091 99.2813 69.0137 98.7053 68.4027 98.0573ZM70.8469 95.6095C72.069 96.8334 72.6801 98.2013 72.6801 99.6052C72.6801 101.045 72.069 102.377 70.8109 103.601C69.5888 104.825 68.2589 105.437 66.857 105.437C65.4192 105.437 64.0893 104.825 62.8672 103.601C61.6451 102.377 61.034 101.045 61.034 99.6052C61.034 98.1653 61.6451 96.8334 62.8312 95.6095C64.0533 94.3856 65.3833 93.7736 66.8211 93.7736C68.2948 93.7736 69.6248 94.3856 70.8469 95.6095ZM66.8211 107.237L63.8377 110.225L58.7335 109.289L58.5538 110.728L60.9621 113.14L58.5538 115.552L50.9695 107.957L53.3778 105.545L55.8939 108.065L55.9658 102.953L58.8773 100.001L58.6976 105.797L66.8211 107.237Z" fill="white"/> </g> <defs> <clipPath id="clip0"> <rect width="117" height="118" fill="white"/> </clipPath> </defs> </svg> ',
      menu: [
        {
          code: "apie-mus",
          title: "Apie mus",
        },
        {
          code: "kontaktai",
          title: "Kontaktai",
        },
      ],
    };
  },
  components: { menuButton },
  computed: {
    ...mapState({
      user: (state) => state.user,
      userID: (state) => state.userID,
      slideOutOpen: (state) => state.slideOutOpen,
      cartActive: (state) => state.cartActive,
      tempUserID: (state) => state.tempUserID,
      cartContent: (state) => state.cartContent,
    }),
    getCartItemsNumber() {
      if (!this.cartContent) return;
      let total = 0;
      for (let itemKey in this.cartContent) {
        total += this.cartContent[itemKey].qty;
      }
      return total;
    },
  },
  mounted() {
    const self = this;
    self.windowWidth = window.innerWidth;
    window.addEventListener("resize", function() {
      self.windowWidth = self.$root.windowWidth = window.innerWidth;
    });
  },
  methods: {
    hideShoppingCart() {
      setTimeout(() => {
        if (!this.cartActive) {
          this.showShoppingCart = false;
        }
      }, 500);
    },
    openCart() {
      if (this.$route.name !== "atsiskaityti") {
        this.$router.push("/atsiskaityti").catch(() => {});
      }
    },
    showCartContent() {
      if (!this.cartContent || !Object.keys(this.cartContent).length) {
        this.$root.notify("Krepšelis yra tuščias", "info");
        return;
      }
      this.$root.showPurchaseScreen = true;
    },
    openAccount() {
      if (this.user) {
        this.$router.push("/paskyra");
      } else {
        this.$store.commit("toggleShowLoginModal", true);
      }
    },
    scrollTo(code) {
      const offsetTop = document.getElementById(code).offsetTop;
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });
    },
    showAccount(val) {
      if (this.windowWidth < 600) {
        this.shoppingCartActive = val;
      }
    },
  },
};
</script>

<style>
.fade-item {
  display: inline-block;
  margin-right: 10px;
}
.fade-leave-active {
  transition: all 0.3s;
}
.fade-enter, .fade-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
